import {useMutation} from "@tanstack/react-query";

import {googleLoginService} from "../services/account/googleLogin.service";
import {useAuthStore} from "../store/useAuth.store";
import useGetAppConfig from "./useGetAppConfig";

// Backend codes returned when the Google account is not yet a registered user.
// In the login-only flow we cannot complete the KYC step here, so we surface a
// dedicated message asking the user to register first.
const NEW_USER_CODES = new Set(["verification_required", "verification_expired", "verification_invalid"]);

const useGoogleLogin = () => {
  const login = useAuthStore(state => state.login);
  const {refetch} = useGetAppConfig();

  const {
    data,
    isError,
    isPending,
    error,
    mutate: postGoogleLogin,
    isSuccess,
  } = useMutation({
    mutationKey: ["google-login"],
    mutationFn: googleLoginService,
    onSuccess: ({data}) => {
      login(data);
      refetch();
    },
    onError: _error => {},
  });

  const isNewUser = Boolean(error?.code && NEW_USER_CODES.has(error.code));

  return {
    postGoogleLogin,
    data,
    isError,
    isPending,
    isSuccess,
    error,
    isNewUser,
  };
};

export default useGoogleLogin;
